export type AboutDataKeys = 'GENERAL' | 'For Tutees' | 'For Tutors';
interface AboutDataValues {
  title: string;
  content: string;
}

export const AboutData: Record<
  AboutDataKeys,
  Record<keyof AboutDataValues, string>[]
> = {
  GENERAL: [
    {
      title: 'How does it work?',
      content: 'Please see our article,',
    },
    {
      title: 'How do I remove my account/details?',
      content: `Please contact our -customer service team- confirming
            you wish to remove your account. For security reasons,
            please ensure that you contact us using the email address
            associated with your Vital Educators's account.`,
    },
    {
      title: 'How do I contact you?',
      content: ` Please use the contact form at the bottom of the page to
            contact our support services. Our office hours are 8am-7pm
            seven days a week. Your enquiry is important to us and we
            always aim to respond promptly and wherever possible
            within one hour of receipt of your enquiry (during office
            hours)`,
    },
  ],
  'For Tutees': [
    {
      title: 'How do I find and contact a tutor?',
      content: `Please use the search function to find a tutor. You can
            search by subject, location, tutor name or keyword. Once
            you have found a tutor you can contact them directly via
            the 'Contact Tutor' button on their profile. You can also
            contact us and we will be happy to help you find a tutor.`,
    },
    {
      title: 'How does payment work?',
      content: `Once you are happy to proceed with your tutor, we ask you
        to pay the Vital Educators finder’s fee to receive your
        tutor’s personal contact information. Vital Educators does
        not handle payment for the lessons, you will need to pay
        this to your tutor directly by whichever method you and
        your tutor agree is most suitable.`,
    },
    {
      title: 'Are your tutors DBS checked/ What checks do you do on tutors?',
      content: ` Vital Educators are a tutor / student matching service and
        all tutors who display their profile on the site are self
        employed. Private tuition is not classified as a
        'regulated activity' under government legislation and as
        such it is not essential for a private tutor to hold a DBS
        check. Some of our registered tutors do possess DBS checks
        because they are also employed as school teachers but we
        cannot vouch for these checks. Vital Educators are legally
        required to collect and hold two references for registered
        tutors in accordance with the employment agency
        regulations and the Information Commissioner’s Office with
        whom we are registered. We are also required to complete
        identity and address checks on all of our registered
        tutors. Background checks (references, photo identity
        documents and address checks) and individually reviewed by
        our compliance manager. Any qualifications we have on file
        for the tutor will be indicated on their profile (however
        please note that it is not compulsory for a tutor to have
        or display qualifications`,
    },
    {
      title: 'Can I leave anonymous feedback?',
      content: `Only registered tutees (verified clients) can leave
        feedback on a tutor’s profile and only their forename will
        display. We don’t permit anonymous feedback from
        individuals outside our website.`,
    },
    {
      title: 'Can I edit/update feedback for my tutor?',
      content: 'Yes, you can. Please contact customer service.',
    },
    {
      title: 'Do you accept any alternative payment methods?',
      content: 'The only alternative payment method we accept is via bank transfer. Please send an email to -customer services- if you wish to pay via bank transfer. We will forward the details via email to you.'
    },
    {
      title: ` What happens if I need to cancel or if I need to change my
     tutor?`,
      content: `We appreciate that sometimes things don’t work out. We
     want you to receive a positive experience with Vital
     Educators and will endeavour to do our best to help you
     should a problem arise. Please -Contact us- to discuss this with
     us so we can address any issue you may face.`,
    },
  ],
  'For Tutors': [
    {
      title: 'How do I register as a tutor?',
      content: `To register as a tutor you must be aged eighteen and over
        and be able to supply us with at least two references,
        proof of photo identity and proof of address. This
        information can be securely submitted in the security
        section of your tutoring account. You will need to create
        your own profile, detailing your knowledge and experience,
        in order to showcase your tuition services.
        `,
    },
    {
      title: 'How does payment work?',
      content: ` Vital Educators acts as a matching platform. As a
        self-employed individual, you will be responsible for
        collecting payment for the lessons, and declaring any
        earnings to HMRC.`,
    },
    {
      title: 'What makes us unique?',
      content: ` Unlike other platforms, we do not take any percentage of
        tutor’s pay from them.`,
    },
    {
      title: 'Do I need a DBS Check?',
      content: `Private tuition is not classified as ‘regulated activity’
        under government legislation. A DBS check is not required
        to be a private tutor as a parent/guardian is expected to
        be present at all times. If you do have a DBS check,
        please bring this to your first lesson.`,
    },
    {
      title: 'How much does it cost?',
      content: `It is free to advertise your services with Vital
        Educators. We do not charge any commission.`,
    },
    {
      title:
        ' I understand tutees can create feedback about me, how does this work?',
      content: `Vital Educators allow all existing tutees to leave
        feedback. After one month we invite tutees to create a
        brief comment about their tutor. This is because the
        tuition industry works on referrals: the more good
        feedback you receive as a tutor, the more enquiries you
        are likely to attract.`,
    },
    {
      title: `Why isn’t my profile on the search?`,
      content: `If you are unable to see your profile on our search
        listings, it is likely that you have not yet completed
        your security checks. Another reason could be that you
        haven’t set the travel options correctly, you can check
        this from your member’s area.`,
    },
    {
      title: 'I am unhappy with my feedback, what can I do?',
      content: `We strongly believe in maintaining the integrity of our
        feedback system and core to that is allowing students to
        express their real opinions of the working relationships
        formed through our service. Our values include
        transparency and openness, so once a tutor has been
        reviewed by a client, we don’t remove their review. Please
        contact our support team for advice on how to manage your
        ratings.`,
    },
    {
      title: 'Tutor Safety',
      content: ` A parent or guardian should be present at all times if you
        are tutoring a child under the age of 18. When meeting for
        the first time, we strongly recommend that both parties
        meet in a safe public place such as a coffee shop or
        library. Always tell someone else when and where you are
        going to meet. If tuition is taking place at home, we
        would recommend that someone else is present in the
        property.`,
    },
  ],
};
